import React from "react";
import { useLocation } from "react-router-dom";
//
import { Typography } from "@/components";
//
import { CustomBox } from "./style";

function NotFound(props) {
  const { pathname } = useLocation();
  return (
    <CustomBox id="error-page">
      <Typography variant="h3" paragraph>
        Oops!
      </Typography>
      <Typography variant="subtitle1" sx={{ display: "initial" }}>
        Desculpe, o caminho{" "}
        <Typography fontStyle="italic" component="span">
          {pathname}
        </Typography>{" "}
        não pode encontrado
      </Typography>
    </CustomBox>
  );
}

export default NotFound;
